var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVehicleInfoInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3389 5.33337H12.5714C10.4164 5.33337 9.33894 5.33337 8.66947 6.02764C8 6.7219 8 7.83931 8 10.0741V21.926C8 24.1608 8 25.2782 8.66947 25.9724C9.33894 26.6667 10.4164 26.6667 12.5714 26.6667H19.4286C21.5836 26.6667 22.6611 26.6667 23.3305 25.9724C24 25.2782 24 24.1608 24 21.926V12.2411C24 11.7567 24 11.5145 23.913 11.2967C23.826 11.0789 23.6609 10.9076 23.3305 10.565L18.9552 6.02764C18.6249 5.68508 18.4597 5.51381 18.2497 5.42359C18.0397 5.33337 17.8061 5.33337 17.3389 5.33337Z",
    stroke: "#A9A9A9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.3334L20 17.3334",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.3334L17.3333 21.3334",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 5.33337V9.77782C17.3335 10.8254 17.3335 11.3492 17.6589 11.6746C17.9844 12 18.5082 12 19.5557 12H24.0002",
    stroke: "#A9A9A9",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleInfoInactive);
export default __webpack_public_path__ + "static/media/vehicle-info-inactive.c32d201fd64b1a0cc07eda5a2698a309.svg";
export { ForwardRef as ReactComponent };